import React from "react";
import { Routes, Route } from "react-router-dom";
import LandingPage from "../pages/LandingPage";
import TentangGiliIyang from "../pages/TentangGiliIyang";
import PaketWisata from "../pages/LandingPage/paket/PaketWisata";
import DetailPaketWisata from "../pages/DetailPaketWisata/DetailPaketWisata";
import DetailContent from "../pages/DetailContent/DetailContent";
import ContentHeader from "../components/Header/ContentHeader";

const SetupRouters = () => {
    return (
        <Routes>
            {/* LandingPage Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/#paket-wisata" element={<PaketWisata />} />
            <Route path="/tentang-gili-iyang" element={<TentangGiliIyang />} />
            <Route path="/paket/:id" exact element={<DetailPaketWisata />} />
            <Route path="/:type/:id" exact element={<DetailContent />} />
            <Route path="/:slug" exact element={<ContentHeader />} />
        </Routes>
    )
};

export default SetupRouters;